import { render, staticRenderFns } from "./UploadEditVideo.vue?vue&type=template&id=926851ec&scoped=true&"
import script from "./UploadEditVideo.vue?vue&type=script&lang=js&"
export * from "./UploadEditVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926851ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926851ec')) {
      api.createRecord('926851ec', component.options)
    } else {
      api.reload('926851ec', component.options)
    }
    module.hot.accept("./UploadEditVideo.vue?vue&type=template&id=926851ec&scoped=true&", function () {
      api.rerender('926851ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/UploadEditVideo.vue"
export default component.exports